// tslint:disable:no-submodule-imports
import * as faSignOutAlt from '@fortawesome/fontawesome-free-solid/faSignOutAlt';
import * as faUser from '@fortawesome/fontawesome-free-solid/faUser';
// tslint:enable:no-submodule-imports
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import * as React from 'react';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from 'reactstrap';
import { compose, setDisplayName } from 'recompose';
import withToggleState, { ToggleStateProps } from '../withToggleState';
import DisconnectDropdownItem from './DisconnectDropdownItem';
import { LoggedInUserProps, withLoggedInUser } from './withLoggedInUser';
import withLogout, { LogoutProps } from './withLogout';

export interface MainNavbarProps {
    isOpen: boolean;
    toggleIsOpen: () => void;
}

const LogoutButton = withLogout(({ logout }: LogoutProps) => (
    <DropdownItem onClick={logout}>
        <FontAwesomeIcon icon={faSignOutAlt} className="text-primary mr-2" />{' '}
        Sign out
    </DropdownItem>
));

export default compose(
    withLoggedInUser,
    withToggleState(),
    setDisplayName('LoginDropdown')
)(({ loggedInUser, active, toggle }: LoggedInUserProps & ToggleStateProps) => {
    if (!loggedInUser) {
        return null;
    }
    return (
        <Dropdown
            group={true}
            nav={true}
            inNavbar={true}
            size="sm"
            isOpen={active}
            toggle={toggle}
        >
            <DropdownToggle nav={true} caret={true}>
                <FontAwesomeIcon icon={faUser} className="mr-2 text-primary" />
                <span className="d-none d-lg-inline">
                    Signed in as {loggedInUser.name}{' '}
                </span>
            </DropdownToggle>
            <DropdownMenu right={true}>
                <LogoutButton />
                <DropdownItem divider={true} />
                <DisconnectDropdownItem />
            </DropdownMenu>
        </Dropdown>
    );
});



// WEBPACK FOOTER //
// ./src/client/components/Login/LoginDropdown.tsx